import type { NodeId, NodeSn } from '@ipfabric/utils';
import type { GraphData } from 'components/Graph/model/GraphData';
import { record } from 'fp-ts';

export const findNodeIdByNodeSn = (
  graphData: GraphData,
  nodeSn: NodeSn | null,
): NodeId | null => {
  const nodeIds: NodeId[] = record.keys(graphData.nodes);
  return (
    nodeIds.find((nodeId) => graphData.nodes[nodeId]?.sn === nodeSn) ?? null
  );
};
